module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-loan-container"
  }, [_c('section', {
    ref: "applyLoan",
    staticClass: "apply-loan"
  }, [_c('keep-alive', [_c('router-view', {
    ref: "applyLoanRouterView",
    staticClass: "apply-loan__router-view"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25dcc4ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ApplyLoan.vue
// module id = 1955
// module chunks = 5